<template>
  <CommonPanel title="待办提醒">
    <a-skeleton :loading="unifiedTaskSummary.length === 0" active :paragraph="{rows: 4}" />
    <div class="container" v-if="unifiedTaskSummary.length > 0">
      <div v-for="(v, index) in unifiedTaskSummary" :key="index" class="card-container">
        <h3><a :href="v.pcUrl" target="_blank">{{v.taskTotalCount | formatTaskTotalCount}}</a></h3>
        <label>{{v.sceneName}}</label>
      </div>
    </div>
  </CommonPanel>
</template>
<script>
  import CommonPanel from "@/components/common-panel/index"
  import { mapState } from 'vuex'
  import { Skeleton } from 'ant-design-vue'
  export default {
    name: 'todo-reminder',
    components: {
      CommonPanel,
      [Skeleton.name]: Skeleton
    },
    computed: {
      ...mapState(['unifiedTaskSummary']),
    },
    filters: {
      formatTaskTotalCount(v) {
        if (isNaN(v)) {
          return 0
        } else {
          return v
        }
      }
    }
  }
</script>
<style scoped lang="scss">
  .container {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    justify-items: center;
  }
  .card-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: calc((100% - 45px)/4);
    /* width: 148px; */
    height: 80px;
    background: #FBFBFB;
    border-radius: 2px;
    margin-bottom: 15px;
    margin-right: 15px;
    &:nth-child(4n) {
      margin-right: 0;
    }
    h3 {
      font-size: 20px;
      /* font-family: MicrosoftYaHei, PingFangSC-Medium, PingFang SC; */
      font-weight: 600;
      color: #1C7AE5;
      line-height: 24px;
      margin-bottom: 4px;
      a {
        text-decoration: none;
      }
    }
    label {
      font-size: 14px;
      font-family: MicrosoftYaHei, PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 18px;
    }
  }
</style>
